export enum PaymentFormId {
  AddCreditCard = 'add-credit-card-form',
  UpgradePlan = 'upgrade-plan-payment-form',
  DowngradePlan = 'downgrade-plan-payment-form',
  UpdateBillingInfo = 'update-billing-info-form',
  FixMonkey = 'fix-monkey-payment-form', // Still in JS
  TopUp = 'top-up-payment-form', // Still in JS
}
